<template>
  <div ref="domRef" :class="['base-card-info', marginBottom ? 'mb-0' : '']">
    <div class="info-card-title">
      营业执照信息
    </div>
    <change-record-container>
      <template #before>
        <div class="left-list gap-y-[14px]">
          <div
            v-if="!deepEqualField(baseInfo?.pre?.companyBusiness?.businessLicensePic, baseInfo?.post?.companyBusiness?.businessLicensePic)"
            class="item"
          >
            <div class="label">
              营业执照照片
            </div>
            <div class="value">
              <div class="business-license-box">
                <img
                  :src="baseInfo?.pre?.companyBusiness?.businessLicensePic"
                >
              </div>
            </div>
          </div>
          <div
            v-if="!deepEqualField(baseInfo?.pre?.companyBusiness?.name, baseInfo?.post?.companyBusiness?.name)"
            class="item"
          >
            <div class="label">
              企业名称
            </div>
            <div class="value">
              {{ isNull(baseInfo?.pre?.companyBusiness?.name) ? '--' : baseInfo?.pre?.companyBusiness?.name }}
            </div>
          </div>
          <div
            v-if="!deepEqualField(baseInfo?.pre?.companyBusiness?.shortName, baseInfo?.post?.companyBusiness?.shortName)"
            class="item"
          >
            <div class="label">
              企业简称
            </div>
            <div class="value">
              {{ isNull(baseInfo?.pre?.companyBusiness?.shortName) ? '--' : baseInfo?.pre?.companyBusiness?.shortName }}
            </div>
          </div>
          <div
            v-if="!deepEqualField(baseInfo?.pre?.companyBusiness?.legalName, baseInfo?.post?.companyBusiness?.legalName)"
            class="item"
          >
            <div class="label">
              法定代表人姓名
            </div>
            <div class="value">
              {{ isNull(baseInfo?.pre?.companyBusiness?.legalName) ? '--' : baseInfo?.pre?.companyBusiness?.legalName }}
            </div>
          </div>
          <div
            v-if="!deepEqualField(baseInfo?.pre?.companyBusiness?.businessLicenseStartDate, baseInfo?.post?.companyBusiness?.businessLicenseStartDate) ||
              !deepEqualField(baseInfo?.pre?.companyBusiness?.businessLicenseEndDate, baseInfo?.post?.companyBusiness?.businessLicenseEndDate)"
            class="item"
          >
            <div class="label">
              营业执照有效期
            </div>
            <div class="value">
              <span>{{ baseInfo?.pre?.companyBusiness?.businessLicenseStartDate }}</span>
              <span> ~ </span>
              <span>{{ baseInfo?.pre?.companyBusiness?.businessLicenseEndDate }}</span>
              <span v-if="['29991231', '2999-12-31'].includes(baseInfo?.pre?.companyBusiness?.businessLicenseEndDate)">长期</span>
            </div>
          </div>
          <div
            v-if="!deepEqualField(baseInfo?.pre?.companyBusiness?.address, baseInfo?.post?.companyBusiness?.address)"
            class="item"
          >
            <div class="label">
              注册地址
            </div>
            <div class="value">
              {{ isNull(baseInfo?.pre?.companyBusiness?.address) ? '--' : baseInfo?.pre?.companyBusiness?.address }}
            </div>
          </div>
          <div
            v-if="!deepEqualField(baseInfo?.pre?.companyBusiness?.businessScope, baseInfo?.post?.companyBusiness?.businessScope)"
            class="item"
          >
            <div class="label">
              经营范围
            </div>
            <div class="value">
              {{ isNull(baseInfo?.pre?.companyBusiness?.businessScope) ? '--' : baseInfo?.pre?.companyBusiness?.businessScope }}
            </div>
          </div>
        </div>
      </template>
      <template #after>
        <div class="left-list gap-y-[14px]">
          <div
            v-if="!deepEqualField(baseInfo?.pre?.companyBusiness?.businessLicensePic, baseInfo?.post?.companyBusiness?.businessLicensePic)"
            class="item"
          >
            <div class="label">
              营业执照照片
            </div>
            <div class="value">
              <div class="business-license-box">
                <img
                  :src="baseInfo?.post?.companyBusiness?.businessLicensePic"
                >
              </div>
            </div>
          </div>
          <div
            v-if="!deepEqualField(baseInfo?.pre?.companyBusiness?.name, baseInfo?.post?.companyBusiness?.name)"
            class="item"
          >
            <div class="label">
              企业名称
            </div>
            <div class="value">
              {{ isNull(baseInfo?.post?.companyBusiness?.name) ? '--' : baseInfo?.post?.companyBusiness?.name }}
            </div>
          </div>
          <div
            v-if="!deepEqualField(baseInfo?.pre?.companyBusiness?.shortName, baseInfo?.post?.companyBusiness?.shortName)"
            class="item"
          >
            <div class="label">
              企业简称
            </div>
            <div class="value">
              {{ isNull(baseInfo?.post?.companyBusiness?.shortName) ? '--' : baseInfo?.post?.companyBusiness?.shortName }}
            </div>
          </div>
          <div
            v-if="!deepEqualField(baseInfo?.pre?.companyBusiness?.legalName, baseInfo?.post?.companyBusiness?.legalName)"
            class="item"
          >
            <div class="label">
              法定代表人姓名
            </div>
            <div class="value">
              {{ isNull(baseInfo?.post?.companyBusiness?.legalName) ? '--' : baseInfo?.post?.companyBusiness?.legalName }}
            </div>
          </div>
          <div
            v-if="!deepEqualField(baseInfo?.pre?.companyBusiness?.businessLicenseStartDate, baseInfo?.post?.companyBusiness?.businessLicenseStartDate) ||
              !deepEqualField(baseInfo?.pre?.companyBusiness?.businessLicenseEndDate, baseInfo?.post?.companyBusiness?.businessLicenseEndDate)"
            class="item"
          >
            <div class="label">
              营业执照有效期
            </div>
            <div class="value">
              <span>{{ baseInfo?.post?.companyBusiness?.businessLicenseStartDate }}</span>
              <span> ~ </span>
              <span>{{ baseInfo?.post?.companyBusiness?.businessLicenseEndDate }}</span>
              <span v-if="['29991231', '2999-12-31'].includes(baseInfo?.post?.companyBusiness?.businessLicenseEndDate)">长期</span>
            </div>
          </div>
          <div
            v-if="!deepEqualField(baseInfo?.pre?.companyBusiness?.address, baseInfo?.post?.companyBusiness?.address)"
            class="item"
          >
            <div class="label">
              注册地址
            </div>
            <div class="value">
              {{ isNull(baseInfo?.post?.companyBusiness?.address) ? '--' : baseInfo?.post?.companyBusiness?.address }}
            </div>
          </div>
          <div
            v-if="!deepEqualField(baseInfo?.pre?.companyBusiness?.businessScope, baseInfo?.post?.companyBusiness?.businessScope)"
            class="item"
          >
            <div class="label">
              经营范围
            </div>
            <div class="value">
              {{ isNull(baseInfo?.post?.companyBusiness?.businessScope) ? '--' : baseInfo?.post?.companyBusiness?.businessScope }}
            </div>
          </div>
        </div>
      </template>
    </change-record-container>
  </div>
</template>

<script setup lang="ts">
import { deepEqualField, isNull } from '@core/tools';
import ChangeRecordContainer from './change-record-container.vue';
import { useElementImgPreview } from '@vue3/components';
import { ICompanyChangeRecord } from '@core/main/types';
import { inject, ref } from 'vue';

defineOptions({ name: 'BusinessLicenseInfo' }); // 账户中心 - 营业执照信息

const domRef = ref<HTMLDivElement>();

useElementImgPreview(domRef);

defineProps({
  marginBottom: {
    type: Boolean,
    default: false,
  },
});

const baseInfo = inject('baseInfo') as ICompanyChangeRecord;
</script>
